module.exports = __webpack_public_path__ + "assets/img/fuguoing1.c8cc5f2c.png";